<script setup>
import { ref, defineEmits, getCurrentInstance } from "vue";
import CryptoJS from 'crypto-js';

const userName = ref("");
const userId = ref(null)
const roomId = ref(null)
const generatedUrl = ref("");
const showPopup = ref(false);
const APP_ID = ref("");
const customMinutes = ref(15); // Default to 15 minutes

const emit = defineEmits(["close"]);
const { appContext } = getCurrentInstance();
APP_ID.value = appContext.config.globalProperties.$APP_ID;

const generateCustomLink = () => {
  const seconds = customMinutes.value * 60; // Convert minutes to seconds
  if (seconds > 0) {
    generateLink(seconds);
  } else {
    alert("Please enter a valid number of minutes.");
  }
}

const generateLink = async (expiration) => {
  if (!userId.value) {
    alert("Please select a robot!");
    return;
  }

  // Send the userId to the server and fetch the data
  try {
    const secretId = appContext.config.globalProperties.$USER.secretId;
    const secretKey = appContext.config.globalProperties.$USER.secretKey;
    roomId.value = secretId + "-" + userId.value;
    const url = "/api/room/" + roomId.value + "?secret_id=" + secretId + "&secret_key=" + secretKey + "&user_id=" + userId.value + "&expiration=" + expiration; // Dynamic expiration time
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    const appId = APP_ID.value;
    const token = `${roomId.value}:${userId.value}:${data.rtc_token}:${data.rtm_token}:${appId}`
    const encryptionKey = 'botfighting123'
    const encryptedToken = btoa(CryptoJS.AES.encrypt(token, encryptionKey).toString())
    generatedUrl.value = `https://rtcrobot.com/teleop/${encryptedToken}`;

    showPopup.value = true;

  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to retrieve data from server.");
  }
};

const copyUrl = async () => {
  try {
    await navigator.clipboard.writeText(generatedUrl.value);
    alert("URL copied to clipboard!");
  } catch (err) {
    alert("Failed to copy URL!");
  }
};

const closeGenerator = () => {
  userName.value = "";
  userId.value = null;
  generatedUrl.value = "";
  showPopup.value = false;
  emit("close");
};
</script>

<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" v-if="!showPopup">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-dark text-light p-4">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Test Drive</h5>
          <button type="button" class="btn-close" @click="closeGenerator"></button>
        </div>
        <div class="modal-body">

          <div class="d-flex align-items-center">
            <label for="botId" class="form-label mb-0 me-2" style="width: 30%;">Bot</label>
            <input type="text" class="form-control bg-secondary text-white" id="inputP1" v-model="userId">
          </div>
        </div>

        <div class="modal-footer">
          <div class="input-group" style="width: 200px; display: inline-flex; align-items: center;">
            <input type="number" v-model.number="customMinutes" min="1" class="form-control" placeholder="Minutes">
            <button class="btn btn-primary" @click="generateCustomLink">Generate</button>
          </div>
          <button class="btn btn-secondary" @click="closeGenerator">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Result Modal -->
  <div v-if="showPopup" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-dark text-light p-4">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Your Test Link</h5>
          <button type="button" class="btn-close" @click="closeGenerator"></button>
        </div>
        <div class="modal-body">
          <div class="d-flex align-items-center justify-content-start mb-2">
            <p class="mb-0 me-2"><strong>Robot:</strong></p>
            <p class="mb-0">{{ userId }}</p>
          </div>

          <div class="d-flex align-items-center justify-content-start mb-2">
            <p class="mb-0 me-2"><strong>Duration:</strong></p>
            <p class="mb-0">{{ customMinutes }} minutes</p>
          </div>

          <!-- Link content aligned to the left -->
          <div class="d-flex align-items-center justify-content-start">
            <p class="mb-0 me-2"><strong>Link:</strong></p>
            <input
              type="text"
              class="form-control bg-secondary text-white w-75"
              :value="generatedUrl"
              readonly
            />
            <button class="btn btn-primary ms-2" @click="copyUrl">Copy</button>
          </div>

        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeGenerator">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
